export default __webpack_public_path__ + "static/media/xml.4edbfc59.png";